import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { validationSchema } from './addressYupValidator';

import {
	FormikTextInput,
	FormikSelect,
	Text,
	PrimaryButton,
	Alert,
} from '@stashinvest/ui';
import { states } from 'stash/constants/places';
import {
	SignUpWrapper,
	SignUpWrapperInner,
} from 'stash/components/sign-up/SignUpScreenLayout';
import { BanjoString } from '@stashinvest/react-banjo';

function FormComponent() {
	return (
		<Form>
			<FormikTextInput name="addressLine1" label="Address 1" />
			<FormikTextInput name="addressLine2" label="Address 2" placeholder=" " />
			<FormikTextInput name="city" label="City" />
			<FormikSelect name="state" label="State">
				{states.map((state) => (
					<option key={state.code} value={state.code}>
						{state.name}
					</option>
				))}
			</FormikSelect>
			<FormikTextInput name="postalCode" label="Zip Code" />
			<PrimaryButton type="submit">Save and continue</PrimaryButton>
		</Form>
	);
}

function ConfirmAddressScreen(props) {
	return (
		<SignUpWrapper>
			<Text.H1 size={3} mb="s">
				What residential mailing address should we use for your new debit account?
			</Text.H1>
			<SignUpWrapperInner>
				<Text mb="l">
					<BanjoString stringId={'information/giveContext/addressDetails'} />
				</Text>
				<Formik
					initialValues={props.initialAddress}
					validationSchema={validationSchema}
					onSubmit={props.handleSubmit}
					component={FormComponent}
				/>
				{props.verifyAddress.error && (
					<Alert variant="error" mt="s">
						There was a problem with your address, please review and try again.
					</Alert>
				)}
			</SignUpWrapperInner>
		</SignUpWrapper>
	);
}

ConfirmAddressScreen.propTypes = {
	initialAddress: PropTypes.object,
	handleSubmit: PropTypes.func,
};

export default ConfirmAddressScreen;
